export const isE2ETestingUser = (email: string) => {
  if (!email) return true;

  const regex = /^test-\w+@levity\.ai$/;

  return regex.test(email);
};
